import { breakpoints } from 'themes';

export const getSuggestionListPositionStyle = (
  suggestionListEle,
  inputEle,
  viewportHeight,
) => {
  const { bottom: inputBottom, height: inputHeight } =
    inputEle?.getBoundingClientRect() ?? {};

  const { height: listHeight } =
    suggestionListEle?.getBoundingClientRect() ?? {};

  const enoughBottom = inputBottom + 4 + listHeight < viewportHeight;

  const isOneColumnLayout = window.innerWidth <= breakpoints.md;

  // when one column, always show at top, so not overlay send button
  if (isOneColumnLayout) {
    return { bottom: inputHeight * 2 + 4 + 12 };
  }

  return enoughBottom
    ? {
        top: inputHeight + 20 + 4,
      }
    : { bottom: inputHeight + 4 };
};
